import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation uploadOfflineReading($data: uploadOfflineReadingInput!) {
    uploadOfflineReading(data: $data) {
      addedReadings
      duplicateReadings
      errorReadings
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.UploadOfflineReadingState = {
  result: null,
  error: null,
  loading: false
};

export const uploadOfflineReadingRequest = createAsyncThunk<
  TYPES.UploadOfflineReadingResponse,
  {data: TYPES.UploadOfflineReadingInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'reading/upload_offline_reading',
  async (
  params: {data: TYPES.UploadOfflineReadingInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.uploadOfflineReading;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const uploadOfflineReadingSlice = createSlice({
  name: 'upload_offline_reading',
  initialState: initialState,
  reducers: {
    uploadOfflineReadingClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(uploadOfflineReadingRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(uploadOfflineReadingRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(uploadOfflineReadingRequest.rejected, (state, action) => {
      state.error = action.payload as TYPES.Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { uploadOfflineReadingClear } =
uploadOfflineReadingSlice.actions;

export const uploadOfflineReading = createSelector(
  (state: RootState) => state.reading.uploadOfflineReading.result,
  (state: RootState) => state.reading.uploadOfflineReading.error,
  (state: RootState) => state.reading.uploadOfflineReading.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default uploadOfflineReadingSlice.reducer;